import firebase from "firebase";

const config = {
	apiKey: "AIzaSyD8fWcweI8PUAfsahVifKpSkxbVF_8KTyA",
    authDomain: "native-audio-recorder.firebaseapp.com",
    databaseURL: "https://native-audio-recorder.firebaseio.com",
    projectId: "native-audio-recorder",
    storageBucket: "native-audio-recorder.appspot.com",
    messagingSenderId: "576174500347",
    appId: "1:576174500347:web:f3803366c9b98e83fd835e",
    measurementId: "G-FXR1409DSH",
};

firebase.initializeApp(config);

export default firebase;
